import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Fomentoartesanal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'> {/* container, container-full-width, container container-mh */}
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Fomento Artesanal"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                La contribución social del Programa es mejorar la condición productiva de la actividad artesanal por parte de las Personas Artesanas Hidalguenses, a través de proyectos de Fomento Artesanal, que promuevan acciones para la asignación de espacios para exhibición y venta de artesanías, reconocimiento a la creatividad artesanal y la trayectoria de las Personas Artesanas, así como la capacitación para mejoramiento de la actividad artesanal.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a que las Personas Artesanas tengan mejores condiciones de bienestar, mediante la accesibilidad a los proyectos de Fomento Artesanal, que promuevan acciones para la venta de sus productos con la asignación de espacios, el fortalecimiento de sus actividades económicas, entrega de estímulos y capacitación con el propósito de tener presencia en diversas actividades comerciales para generar e incrementar sus ingresos, adicionalmente estimular su labor con la entrega de reconocimientos económicos adecuados, en la cual la participación promueva sus actividades, bajo el principio de la universalidad relacionado a la igualdad y no discriminación.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas Artesanas mayores de edad, del Estado de Hidalgo, que habiten preferentemente en las localidades de marginación, pobreza extrema, rezago social o con población indígena en el Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                La cobertura del Programa abarca las 12 regiones del Estado de Hidalgo, conforme a la suficiencia presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>  
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Ángeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080, Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Participaciòn Social y Fomento Artesanal</b></li>
                <dd>Blvd. Felipe Ángeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080, Pachuca de Soto, Hgo.</dd>
                <li><b>Dirección General de Fomento Artesanal.</b></li>
                <dd>Blvd. Felipe Ángeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Nora Aidhé Luciano Martínez: Directora General de Fomento Artesanal
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 713 09 66 y 771 713 04 12
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Reglas de Operación</strong></h5>
                <ul>
                <li>
                 <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Fomento_Artesanal_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Convocatorias</strong></h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_HECHO_EN_HIDALGO.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >13ª. EDICIÓN DEL CONCURSO ESTATAL DE ARTESANÍAS “HECHO EN HIDALGO 2026"</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_2.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexos</a>
                </li>
                </ul>
                </ul>
                
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Fomentoartesanal;